import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditLevel from '../../components/levels/FormAddEditLevel';

const CreateLevel = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditLevel />
    </WrapperSection>
);

export default CreateLevel;
